import { __ } from '../../i18n/l10n';
import { type BetslipStatus as BetslipStatusType, BetslipStatuses, BetslipDisplayStatuses } from '../../types/betslip';
import {
  type BetslipStatusType as BetslipHistoryStatusType,
  type BetslipType,
  BetslipTypes,
  BetslipStatus,
} from '../../types/history';

export type BetslipId = number;

export type BetslipDetail = {
  outcomeId: number;
  odds: number;
  isLive?: boolean;
};

export type BetslipStateDataMONOPOLY = {
  familyId: string;
  cardIndex: number;
};

export type BetslipStateDataBOOM = {
  stepId: string;
  boomId: string;
};

export type BetslipStateDataKL = {
  adventureId: number;
  type: string;
  id: string | null;
};

export type BetslipStateDataGR = {
  raceId: string;
  adventureId: number;
  round: string;
  skinId: string;
};

export type BetslipStateDataMISSION = {
  achievementId: number;
  missionId: number;
};

export type BetslipStateData = {
  MONOPOLY?: BetslipStateDataMONOPOLY;
  BOOM?: BetslipStateDataBOOM;
  KL?: BetslipStateDataKL;
  GR?: BetslipStateDataGR;
  MISSION?: BetslipStateDataMISSION;
};

export type BetslipState = {
  betslipId: BetslipId;
  cashoutValue: number | null;
  cashoutAvailable: boolean;
  betslipReference: string;
  status: BetslipStatusType;
  type: number;
  betAmount: number;
  winningsAmount: number | null;
  winningsBonus: number | null;
  possibleWinnings: number | null;
  possibleBonus: number | null;
  globalOdds: number;
  promotionCodeId: string | null;
  promotionTitle: string | null;
  cashoutAllowed: boolean;
  completeBetAllowed: boolean;
  data: BetslipStateData;
  details: Array<BetslipDetail>;
  validationDate: number;
  pendingCashout?: boolean;
  isFavorite?: boolean;
  aamsTicketId?: string;
  freebet?: boolean;
  bankers?: Array<unknown>;
  cnp?: Array<unknown>;
  voidReason?: unknown;
};

export type EntitiesBetslips = {
  [betslipId: BetslipId]: BetslipState;
};

class BetslipEntity {
  static getDisplayStatus = (status: BetslipStatusType, winningsAmount: number): string => {
    if (status === BetslipStatuses.SETTLED) {
      if (winningsAmount > 0) {
        return BetslipDisplayStatuses.WINNING;
      }
      return BetslipDisplayStatuses.LOST;
    }
    return status;
  };

  static getStatusLabel = (status: BetslipHistoryStatusType, winningsAmount: number): string => {
    switch (status) {
      case BetslipStatus.CASHOUT:
        return __('Cashout');
      case BetslipStatus.SETTLED:
        return winningsAmount > 0 ? __('Won') : __('Lost');
      case BetslipStatus.CANCELLED:
        return __('Cancelled');
      case BetslipStatus.TRADER:
        return __('Bet pending');
      case BetslipStatus.REJECTED:
        return __('Refused');
      case BetslipStatus.RUNNING:
        return __('Ongoing');
      default:
        return '...';
    }
  };

  static getTypeLabel = (type: BetslipType): string | null => {
    switch (type) {
      case BetslipTypes.SINGLE:
        return __('Single');
      case BetslipTypes.MULTIPLE:
        return __('Accumulator');
      case BetslipTypes.SYSTEM:
        return __('System');
      case BetslipTypes.GRID:
        return __('Grid');
      case BetslipTypes.BRACKET:
        return __('Bracket');
      default:
        return null;
    }
  };

  static getHeaderDetails = (type: BetslipType, count: number): string | null => {
    const isComboOrSystem = type === BetslipTypes.MULTIPLE || type === BetslipTypes.SYSTEM;

    return isComboOrSystem ? ' (' + __('%1$s selection', count, '%1$s selections') + ')' : null;
  };
}

export { BetslipEntity };
